 (function () {
    'use strict';

     angular.module('tikonApp').constant('ENV', {
            API_BASE_URL: 'https://api.planovin.com/',
            ENVIRONMENT: 'production',
            NEWPANEL_CDN: 'https://panel.planovin.com/v2/'
        });

})()
     
    